import React, { useEffect, useState } from "react";
import moment from "moment";

import AttributeRow from "./attribute-row";

import { getAttributesForReferences, mapAttributesToReadOnlyRow } from "../lib/attribute-data";
import { lookupUUID } from "../../../shared/attribute-uuid";

const ReadOnlyTable = (props) => {
    const [bodyData, setBodyData] = useState({});

    useEffect(() => {
        if (props.referenceProducts.length > 0) {
            getAttributeList();
        }
    }, [props.referenceProducts]);

    const getAttributeList = async () => {
        const refKeys = props.referenceProducts.map((ref) => ref.key);
        const attributeList = await getAttributesForReferences({ pids: [...refKeys] });
        const data = mapAttributesToReadOnlyRow(attributeList, props.referenceProducts);

        setBodyData(data);
    };

    const width = { gridTemplateColumns: `200px repeat(${props.referenceProducts.length}, 1fr)` };
    const bodyRows = Object.keys(bodyData).map((row, i) => {
        return <AttributeRow key={`attributerow_${row}`} id={row} data={bodyData[row]} width={width} />;
    });
    const referenceSubHeaders = props.referenceProducts.map((product, index) => {
        const today = moment();
        const updatedOn = today.diff(product[lookupUUID("updatedOn")], "days") || "-";

        return (
            <div key={product.key}>
                <div>Reference {index + 1}</div>
                <div>{updatedOn} Days Ago</div>
            </div>
        );
    });

    return (
        <div className="product-compare">
            <div className="product-compare-header" style={width}>
                <div></div>
                {referenceSubHeaders}
            </div>

            <div className="product-compare-header1" style={width}>
                {bodyRows}
            </div>
        </div>
    );
};

ReadOnlyTable.defaultProps = {
    referenceAttributes: [],
};

export default ReadOnlyTable;
